import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function Usa() {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm')); // true for mobile/tablet

  return (
    <Box>
    <div style={{ textAlign: "center", fontFamily: "Montserrat, sans-serif" }}>
    <h1
      style={{
        fontWeight: 700,
        marginTop:'45px',
        fontSize:matches?'24': "64px",
        lineHeight: "32px",
        letterSpacing: "0%",
        textAlign: "center",
      }}
    >
      The Ultimate{" "}
      <span
        style={{
          background: "linear-gradient(to right, red, purple, blue)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        USA Experience
      </span>
    </h1>
    <p
  style={{
    fontFamily: "'Segoe Script', cursive",
    fontWeight: 700,
    fontSize:matches?'22': "32px",
    lineHeight: "100%",
    letterSpacing: "0%",
    textAlign: "center",
    marginTop: "20px",
  }}
>
  Here's the Scoop
</p>
  </div>
    <Box sx={{ fontFamily: 'Montserrat', mt: 10, minHeight: matches ? '230vh' : '110vh', position: 'relative' }}>
      
      <Box
        sx={{
          position: 'relative',
          backgroundImage: matches ? 'none' : `url("https://dbqa318yoj3nn.cloudfront.net/curveline.png")`,
          backgroundSize: '100% auto',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          minHeight: matches ? 'auto' : '280vh',
        }}
      >
        {/* 1. Calendar Section */}
        <Box sx={{
          position: 'absolute',
          top: matches ? '-10vh' : '0vh',
          left: matches ? '50%' : '20vw',
          transform: matches ? 'translateX(-50%)' : 'none',
        }}>
          <img src="https://dbqa318yoj3nn.cloudfront.net/CalendarIcon.png" style={{ width: matches ? '220px' : '250px' }} alt="Calendar" />
        </Box>

        <Box sx={{
          position: 'absolute',
          top: matches ? '17vh' : '-3vh',
          left: matches ? '50%' : '65vw',
          transform: matches ? 'translateX(-50%)' : 'none',
          maxWidth: matches ? '170px' : '300px',
        }}>
          <Typography fontSize={matches ? "12px" : "24px"} fontWeight="bold" color="black">
            The total duration of the{' '}
            <Box
              component="span"
              sx={{
                fontFamily: 'Montserrat',
                fontSize: matches ? '24px' : '64px',
                fontWeight: 'bold',
                background: 'linear-gradient(to right, #e84393, #3b82f6)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              trip is 15 Days.
            </Box>
          </Typography>
        </Box>

        {/* 2. Astronaut Section */}
        <Box sx={{
          position: 'absolute',
          top: matches ? '30vh' : '33vh',
          left: matches ? '50%' : '55vw',
          transform: matches ? 'translateX(-50%)' : 'none',
        }}>
          <img src="https://dbqa318yoj3nn.cloudfront.net/StudentreadingIcon.png" style={{ width: matches ? '200px' : '400px' }} alt="Astronaut" />
        </Box>

        <Box sx={{
          position: 'absolute',
          top: matches ? '70vh' : '54vh',
          left: matches ? '50%' : '35vw',
          transform: 'translateX(-50%)',
          maxWidth: '100%',
          width: matches ? '80%' : '650px',
          padding: matches ? '0 15px' : '0',
        }}>
          <Typography variant="h4" fontWeight="bold" color="#2d3436" sx={{ fontFamily: 'Montserrat', fontSize: matches ? '18px' : '28px', textAlign: matches ? 'center' : 'left' }}>
            Students will get a{' '}
            <Typography style={{
              background: 'linear-gradient(90deg, #d946ef, #6366f1)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontWeight: 700,
              fontFamily: 'Montserrat',
              fontSize: matches ? '24px' : '54px',
            }}>
              chance to attend:
            </Typography>
          </Typography>

          <Box sx={{ mt: matches ? 1 : 3 }}>
            {/* List items */}
            <Box display="flex" alignItems="flex-start" mb={matches ? 1 : 2} sx={{ fontFamily: 'Popins', flexDirection: 'row', textAlign: matches ? 'center' : 'left' }}>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: matches ? 30 : 40, // Smaller circle on mobile/tablet
                height: matches ? 30 : 40,
                backgroundColor: '#D9D9D9',
                borderRadius: '50%',
              }}>
                <img src="https://dbqa318yoj3nn.cloudfront.net/training.png" alt="icon1" width={matches ? '20' : '28'} />
              </div>
              <Box sx={{marginLeft:matches?'0px':'8px', fontFamily: 'Popins',marginTop:matches?'8px':'0px', textAlign: matches ? 'center' : 'left' }}>
                <Typography fontWeight="500" sx={{ fontFamily: 'Popins', fontSize: matches ? '12px' : '24px' }}>
                  A Training Workshop at <span style={{ color: '#6366f1', fontWeight: 600 }}>Kennedy Space Centre</span>
                </Typography>
                <Typography color="text.secondary" sx={{ fontFamily: 'Popins', ml: matches ? 0 : 4, mt: 0.5, fontSize: matches ? '10px' : '22px' }}>
                  (One of NASA Field Centres)
                </Typography>
              </Box>
            </Box>

            <Box display="flex" alignItems="flex-start" mb={matches ? 1 : 2} sx={{ flexDirection: 'row', textAlign: matches ? 'center' : 'left' }}>

              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: matches ? 30 : 40, // Smaller circle on mobile/tablet
                height: matches ? 30 : 40,
                backgroundColor: '#D9D9D9',
                borderRadius: '50%',
              }}>
                <img src="https://dbqa318yoj3nn.cloudfront.net/graduation.png" alt="icon2" width={matches ? '20' : '28'}  />
              </div>
              <Typography fontWeight="500" sx={{marginLeft:matches?'5px':'8px',marginTop:matches?'8px':'0px', fontFamily: 'Popins', fontSize: matches ? '12px' : '24px', textAlign: matches ? 'center' : 'left' }}>
                A Guided Program and Orientation of <span style={{ fontFamily: 'Popins', color: '#6366f1', fontWeight: 600 }}>Harvard</span>
              </Typography>
            </Box>

            <Box display="flex" alignItems="flex-start" sx={{ flexDirection: 'row', textAlign: matches ? 'center' : 'left' }}>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: matches ? 30 : 40, // Smaller circle on mobile/tablet
                height: matches ? 30 : 40,
                backgroundColor: '#D9D9D9',
                borderRadius: '50%',
              }}>
                <img src="https://dbqa318yoj3nn.cloudfront.net/Robot_icon.png" alt="icon3" width={matches ? '20' : '28'}  />
              </div>
              <Typography fontWeight="500" sx={{marginLeft:matches?'5px':'8px', marginTop:matches?'8px':'0px', fontFamily: 'Popins', fontSize: matches ? '12px' : '24px', textAlign: matches ? 'center' : 'left' }}>
                Workshop on Robotics/Engineering at <span style={{ color: '#6366f1', fontWeight: 600 }}>MIT</span>
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* 3. Carnival Section */}
        <Box sx={{
          position: 'absolute',
          top: matches ? '100vh' : '125vh',
          left: matches ? '50%' : '80vw',
          transform: 'translateX(-50%)',
          width: matches ? '250px' : '450px',
        }}>
          <img src="https://dbqa318yoj3nn.cloudfront.net/CarnivalIcon.png" style={{ width: '100%' }} alt="Carnival" />
        </Box>

        <Box sx={{
          position: 'absolute',
          top: matches ? '120vh' : '135vh',
          left: matches ? '50%' : '30vw',
          transform: 'translateX(-50%)',
          maxWidth: matches ? '500px' : '800px',
          width: '100%',
          padding: matches ? '0 15px' : '0 20px',
          textAlign: 'center',
        }}>
          <Typography
            fontSize={matches ? "24px" : "64px"}
            fontWeight="bold"
          >
            <span style={{
              background: 'linear-gradient(90deg, #d946ef, #6366f1)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontFamily: 'Montserrat',
              fontWeight: 'bold',
            }}>
              Explore
            </span>
            <span style={{ color: '#6366f1', fontWeight: 'bold' }}>
              {' '}| Learn | Enjoy
            </span>
          </Typography>

          <Typography sx={{fontFamily: 'Popins', fontSize: matches ? '12px' : '24px', fontWeight: '500', mt: 2 }}>
            Students will also get to explore Universal’s Theme Park - Island of Adventure,
            Educational visit to Hershey Chocolate Factory Shop and many more key attractions.
          </Typography>
        </Box>

        {/* 4. Graduate Section */}
        <Box sx={{
          position: 'absolute',
          top: matches ? '140vh' : '175vh',
          left: matches ? '50%' : '20vw',
          transform: 'translateX(-50%)',
          width: matches ? '220px' : '350px',
        }}>
          <img src="https://dbqa318yoj3nn.cloudfront.net/GraduategirlIcon.png" style={{ width: '100%' }} alt="Graduate" />
        </Box>

        <Box sx={{
          position: 'absolute',
          top: matches ? '200vh' : '200vh',
          left: matches ? '50%' : '68vw',
          transform: 'translateX(-50%)',
          maxWidth: '800px',
          width: '100%',
          padding: matches ? '0 15px' : '0 20px',
          textAlign: 'center',
        }}>
          <Typography
            fontWeight="700"
            fontSize={matches ? '28px' : '64px'}
            sx={{
              background: 'linear-gradient(to right, #e84393, #3b82f6)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontFamily: 'Montserrat',
            }}
          >
            Get Certified Globally
          </Typography>
          <Typography sx={{
            mt: 1,
            color: 'black',
            fontFamily:'Popins',
            fontWeight: '500',
            fontSize: matches ? '12px' : '24px',
            lineHeight: 1.6,
          }}>
            After completing the visit, students will receive certifications for their trainings and workshops from the respective institutions they have attended. These certifications will affiliate with NASA, MIT, and Harvard, along with a certificate from Simplifying Skills awarding their participation throughout the Program.
          </Typography>
        </Box>
      </Box>
    </Box>
    </Box>
  );
}
